<template>
  <div class="warp">
    <i class="iconfont iconjinggao"></i>
    <span class="content">{{ tipContent }}</span>
  </div>
</template>

<script>
export default {
  name: 'Headertip',
  props: {
    tipContent: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style lang="less" scoped>
.warp {
  display: flex;
  padding: 5px 20px 20px;
  .content {
    font-size: 14px;
    color: #666;
    padding-left: 5px;
    line-height: 20px;
  }
}
.iconjinggao {
  color: #4359b7;
  width: 15px;
  height: 15px;
  margin-top: 2px;
}
</style>
